const H5PEssay = (attempt, parameters = {}) => {
	const answer = attempt.h5p_response.answer || 'No answer provided.';

	return `
<div class="h5p-essay">
	<p>${answer.replace(/\n/g, '<br>')}</p>
</div>
`;
};

export default H5PEssay;
